// /store/toastStore.js
import { defineStore } from 'pinia'

export const useToastStore = defineStore('toastStore', {
  state: () => ({
    toasts: [] // 用來放所有 Toast 訊息物件
  }),
  actions: {
    /**
     * 加入一則 Toast
     * @param {String} text - 顯示的提示文字
     * @param {String} type - 類型 (可用 'info'|'success'|'warning'|'error' 等)
     * @param {HTMLElement|null} anchorEl - 要錨定的 DOM 元素 (可為 null)
     */
    addToast(text, type = 'info', anchorEl = null) {
      const id = Date.now() // 也可用 uuid() 產生唯一 ID
      // 將 anchorEl 存起來
      this.toasts.push({ id, text, type, anchorEl })
      
      // 設定自動關閉時間 (例如 5 秒)
      setTimeout(() => {
        this.removeToast(id)
      }, 5000)
    },
    /** 移除指定 ID 的 Toast */
    removeToast(id) {
      this.toasts = this.toasts.filter(t => t.id !== id)
    }
  },
})
